import { newsTypes } from '../actions/_news_actions';

const newsDefaultState = [];

export default (state = newsDefaultState, action) => {
  switch (action.type) {
    case newsTypes.FETCH_POSTS_DATA:
      return [...action.newValues];
    case newsTypes.CREATE_NEW:
      return [...state, action.data];
    case newsTypes.EDIT_DATA:
      return state.map((post) => {
        if (post.objectID === action.changes.objectID) {
          return {
            ...post,
            ...action.changes,
          };
        } else {
          return post;
        }
      });
    case newsTypes.REMOVE_JOBS:
      return [...action.newValues];
    default:
      return state;
  }
};
